"use strict";

var utils = require("../other/utils");

module.exports = function (ngModule) {
  ngModule.factory("formlyUtil", formlyUtil);

  formlyUtil.tests = ON_TEST ? require("./formlyUtil.test")(ngModule) : null;

  function formlyUtil() {
    return utils;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./services/formlyUtil.js
 ** module id = 20
 ** module chunks = 0
 **/